import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppAuthService } from '../../../../shared/services/app-auth.service';
import { LayoutService } from '../../services/layout.service';
import { CommonModule } from '@angular/common';
import { Menu, MenuModule } from 'primeng/menu';
import { StyleClassModule } from 'primeng/styleclass';
import { Avatar } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { AppSessionService } from '../../../../shared/session/app-session.service';
import { LogoutRequestBody } from '../../../../shared/models/auth.model';
import { finalize } from 'rxjs';
import { ChangePasswordService } from '../../services/change-password.service';


@Component({
  selector: 'app-topbar',
  imports: [RouterModule, CommonModule, StyleClassModule, AvatarGroupModule, MenubarModule, ButtonModule, MenuModule, Avatar],
  templateUrl: './topbar.component.html'
})
export class TopbarComponent {
  protected readonly layoutService = inject(LayoutService);
  protected readonly appSessionService = inject(AppSessionService);
  private readonly _router = inject(Router);
  private readonly _changePasswordService = inject(ChangePasswordService);
  protected authService = inject(AppAuthService);

  items: MenuItem[] = [
    {
      label: 'Il Progetto',
      routerLink: ['/home/info/il-progetto']
    },
    {
      label: 'Chi Siamo',
      routerLink: ['/home/info/chi-siamo']
    }
  ];

  profileMenu: MenuItem[] = [
    {
      label: 'Cambia Password',
      icon: 'pi pi-key',
      command: () => {
        const userId = this.appSessionService.userInfo?.id;
        // if (!userId) {
        //   console.error('User ID is not defined. Cannot change password.');
        //   return;
        // } else if (userId) {
        //   console.error('User ID is invalid. Cannot change password.');
        //   return;
        // }

        if (userId) {
          this._changePasswordService.showChangePasswordDialog(this.getUserFullName(), '');

        }

      },

    },
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        let reqBody: LogoutRequestBody = {
          refreshToken: this.appSessionService.refreshToken || '',
        }
        this.authService.logout(reqBody).pipe(
          finalize(() => this._router.navigate(['/home'], { replaceUrl: true }))
        ).subscribe();
      },

    }
  ];

  isLoggedIn(): boolean {
    return this.appSessionService.userInfo !== undefined && this.appSessionService.userInfo !== null;
  }

  getUserInitials(): string {
    const user = this.appSessionService.userInfo;

    if (user) {
      const firstName = user.userName || '';
      return (firstName.charAt(0)).toUpperCase();
    }
    return '';
  }

  getUserFullName(): string {
    const user = this.appSessionService.userInfo;
    if (user && user.userName) {
      return `${user.userName}`;
    }
    return '';
  }

}
